import { useParams } from "react-router-dom"
import { ItemsView } from "@/features/items/components/ItemsView"

export default function EquipmentItemsPage() {
  const { equipmentId } = useParams()

return <ItemsView equipmentId={equipmentId!} />
}